import React from "react";
import { Link } from "react-router-dom";
import { COUNTRIES } from "@/data/site";
import { FOOTER } from "@/constants/testIds";
import { Linkedin, Mail, MapPin } from "lucide-react";
import { useT } from "@/i18n";

export default function Footer() {
  const t = useT();
  return (
    <footer
      data-testid={FOOTER.root}
      className="relative border-t border-white/10 bg-[#050F22]"
    >
      <div className="nx-container py-16 md:py-20 grid grid-cols-2 md:grid-cols-5 gap-10">
        <div className="col-span-2">
          <Link to="/" className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-lg bg-gradient-to-br from-[#0057FF] to-[#38D8FF] flex items-center justify-center">
              <svg viewBox="0 0 36 36" className="w-7 h-7 text-white" fill="none">
                <path d="M8 28V8h3.5l13 14V8H28v20h-3.5l-13-14v14H8z" fill="currentColor" />
              </svg>
            </div>
            <div>
              <div className="nx-heading font-bold tracking-tight text-white text-lg">NEXORA</div>
              <div className="text-[10px] uppercase tracking-[0.22em] text-white/55">
                Technologies
              </div>
            </div>
          </Link>
          <p className="mt-5 text-sm text-white/65 leading-relaxed max-w-sm">{t.footer.tagline}</p>
          <div className="mt-6 flex items-center gap-4 text-sm text-white/60">
            <a
              href="mailto:hello@nexora-technologies.eu"
              className="inline-flex items-center gap-2 hover:text-white"
            >
              <Mail className="w-4 h-4" /> hello@nexora-technologies.eu
            </a>
          </div>
          <div className="mt-3 inline-flex items-center gap-2 text-sm text-white/60">
            <MapPin className="w-4 h-4" /> {t.footer.address}
          </div>
        </div>

        <div>
          <div className="text-xs uppercase tracking-[0.2em] text-white/45 mb-4">{t.footer.company}</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/about" className="nx-link">{t.footer.about}</Link></li>
            <li><Link to="/about" className="nx-link">{t.footer.whyNexora}</Link></li>
            <li><Link to="/contact" className="nx-link">{t.footer.contact}</Link></li>
          </ul>
        </div>

        <div>
          <div className="text-xs uppercase tracking-[0.2em] text-white/45 mb-4">{t.footer.servicesCol}</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/ai-transformation" className="nx-link">{t.footer.aiTransformation}</Link></li>
            <li><Link to="/services" className="nx-link">{t.footer.servicesOverview}</Link></li>
            <li><Link to="/industries" className="nx-link">{t.footer.industries}</Link></li>
          </ul>
        </div>

        <div>
          <div className="text-xs uppercase tracking-[0.2em] text-white/45 mb-4">{t.footer.countriesCol}</div>
          <ul className="space-y-2 text-sm">
            {COUNTRIES.map((c) => {
              const key = c.code === "uk" ? "united-kingdom" : c.code === "nl" ? "netherlands" : c.code === "de" ? "germany" : c.code === "ch" ? "switzerland" : "belgium";
              return (
                <li key={c.code}>
                  <Link to={c.path} className="nx-link inline-flex items-center gap-2">
                    <span>{c.flag}</span>
                    {t.countriesNav[key]}
                  </Link>
                </li>
              );
            })}
          </ul>
        </div>
      </div>

      <div className="nx-container pb-10 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-xs text-white/45">
        <div>© {new Date().getFullYear()} Nexora Technologies. {t.footer.copyright}</div>
        <div className="flex items-center gap-4">
          <Linkedin className="w-4 h-4 hover:text-white cursor-pointer" />
          <span>{t.footer.privacy}</span>
          <span>{t.footer.terms}</span>
          <span>{t.footer.cookies}</span>
        </div>
      </div>
    </footer>
  );
}
